import { AbstractPmsApiService } from "./abstract.service";
import { SmsTransaction } from "../models";

/**
 * @class SmsTransactionPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<SmsTransaction>}
 */
export class SmsTransactionPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/sms-transaction(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {SmsTransaction}
     * @protected
     */
    newModel(attributes, ...params) {

        return new SmsTransaction(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<SmsTransaction>>}
     */
    get(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {SmsTransaction} transaction
     * @param {Property} property
     * @returns {Promise.<SmsTransaction>}
     */
    create(transaction, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url, transaction.toObjectExcept('property', 'user'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {SmsTransaction} transaction
     * @returns {Promise.<SmsTransaction>}
     */
    update(transaction) {

        const url = this.url({
            propertyId: transaction.property.id,
            id:         transaction.id
        });

        return this.http
            .put(url, transaction.toObjectExcept('property', 'user'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/sms-transaction.service.js